import React, { useState, useEffect } from 'react'
import '../../../styles/HorairesTarifs.css'

const HorairesTarifs = () => {
  const [données, setDonnées] = useState(null)

  useEffect(() => {
    fetch('/json/HorairesTarifs.json')
      .then((response) => response.json())
      .then((data) => setDonnées(data))
      .catch((error) =>
        console.error('Erreur lors du chargement des données:', error)
      )
  }, [])

  if (!données) {
    return <div>Chargement des données...</div>
  }

  return (
    <div id="HorairesTarifs" className="horairestarifs">
      <div id="section-HorairesTarifs" className="sectionHorairestarifs">
        <div id="image" className="containerImageHorairestarifs">
          <figure id="img_bloc" className="blocImageHorairestarifs">
            {/* <a href="./images/DSLQ2018_08_web.jpg"> */}
            <img
              src="./images/DSLQ2018_08_web.jpg"
              data-src="./images/DSLQ2018_08_web.jpg"
              alt="Association de danse Blanquefort"
              width="954"
              height="605"
            />
            {/* </a> */}
          </figure>
        </div>
        <div id="texte-HorairesTarifs" className="containerTexteHorairestarifs">
          <div id="text_HorairesTarifs-titre" className="titre">
            {données.saison}
            <br />
            <p>{données.dateDemarrage}</p>
          </div>
          <div
            id="text_BLOCK_21OZTGNDPJ"
            className="blockTextHorairestarifs blk-text"
          >
            {données.cours.map((jour, index) => (
              <div key={index}>
                <table className="tableCours">
                  <thead>
                    <tr>
                      <th colSpan="2">
                        {données.lieu.nom}
                        <br />
                        {données.lieu.adresse}{' '}
                        <a
                          href={données.lieu.lienPlan}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Plan d'accès
                        </a>
                      </th>
                    </tr>
                  </thead>
                  <tbody className={`${`fondtableau${(index % 3) + 1}`}`}>
                    <tr>
                      <td colSpan="2">
                        {jour.jour} - {jour.professeur}
                      </td>
                    </tr>
                    {jour.horaires.map((horaire, horaireIndex) => (
                      <tr key={horaireIndex}>
                        <td>{horaire.heure}</td>
                        <td>{horaire.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
            <p style={{ fontSize: '0.8em' }}>{données.note1}</p>
            <p
              className="fondtableau3"
              style={{
                borderStyle: 'solid',
                borderWidth: '2px',
                padding: '5px',
                borderRadius: '10px',
                fontSize: '0.8em',
              }}
            >
              {données.note2}
            </p>
            <table className="tableTarifs">
              <thead>
                <tr>
                  <th colSpan="3">{données.titreTarif}</th>
                </tr>
                <tr>
                  <th></th>
                  <th>Seul</th>
                  <th>Couple</th>
                </tr>
              </thead>
              <tbody>
                {données.tarifs.map((tarif, index) => (
                  <tr
                    key={index}
                    className={`${`fondtableau${index % 2 === 0 ? '1' : '2'}`}`}
                  >
                    <td className="dureeTarif">{tarif.duree}</td>
                    <td>{tarif.seul}</td>
                    <td>{tarif.couple}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div
            id="text_BLOCK_Tarifs"
            className="blockTextHorairestarifs blk-text"
          >
            <p>
              {données.adhesion.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
            <hr style={{ border: '1px solid red' }} />
            <p>
              {données.paiement1.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
            <hr style={{ border: '1px solid red' }} />
            <p>
              {données.paiement2.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HorairesTarifs
